import type { GraphQL, Pax } from '@libs/trip-planner-interfaces';

export function getInputPaxGroupQL(pax: Pax): GraphQL.InputPaxGroupQL[] {
  return pax.map((room) => ({
    numberOfAdults: room.numberOfAdults,
    childAges: room.childAges ?? [],
  }));
}
